import React from "react";
import CustomerRepresenterForm from "./CustomerRepresenterForm";
import MainPageCompenent from './MainPageCompenent';
function CustomerRepresenter(props) {
    return (
        <MainPageCompenent>
            <CustomerRepresenterForm />
        </MainPageCompenent>
    );
}

export default CustomerRepresenter;